import Dashboard from '../containers/dashboard'
import CustomerCompanyPaymentsHistoryManagement from '../containers/customer-company-payments-history-management'

const CustomerCompanyPaymentsHistory = () => {
  return (
    <Dashboard>
      <CustomerCompanyPaymentsHistoryManagement />
    </Dashboard>
  )
}

export default CustomerCompanyPaymentsHistory
